import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  FormControl,
  Button,
  Container,
  InputGroup,
} from "react-bootstrap";
import Enquiry from "./enquirypopup";
import { ProductDropdowns, BASE_URL } from "./utility";

const PRODUCT_LINKS = [
  ["wallpapers", "Wallpapers"],
  ["acousticbaffleceilings", "Acoustic Baffle Ceilings"],
  ["woodenfloorings", "Wooden Floorings"],
  ["claddings", "Claddings"],
  ["awnings", "Awnings"],
  ["blinds", "Blinds"],
  ["wall2wall", "Wall-2-Wall Carpets"],
  ["ceilings", "Ceilings"],
  ["wpcbaffleceilings", "WPC Baffle Ceilings"],
  ["soffitpanels", "Soffit Panels"],
  ["solar", "Solar Films"],
  ["agrass", "Artificial Grass"],
  ["doormats", "Door Mats"],
  ["pvcpanels", "PVC Panels"],
  ["foampanels", "Foam Panels"],
  ["verticalgarden", "Vertical Gardens"],
  ["modulercarpets", "Modular Carpet Tiles"],
  ["nexacarpets", "Nexa Carpets"],
  ["fundermax", "Fundermax"],
  ["aluminiumlouverpanels", "Aluminium Louver Panels"],
  ["indoorwpclouvers", "Indoor WPC Panels"],
  ["outdoorwpclouvers", "Outdoor WPC Panels"],
  ["hpl", "HPL"],
  ["gymfloorings", "Gym Floorings"],
];

class MenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      filteredItems: [],
    };
    this.items = ProductDropdowns;
  }

  handleSearch = (event) => {
    const searchTerm = event.target.value;
    const normalizedSearch = searchTerm.trim().toLowerCase();
    const filteredItems = normalizedSearch
      ? this.items.filter((item) =>
          item.name.toLowerCase().includes(normalizedSearch)
        )
      : [];

    this.setState({ searchTerm, filteredItems });
  };

  handleItemClick = (link) => {
    window.location.href = link;
  };

  render() {
    const { searchTerm, filteredItems } = this.state;

    return (
      <div className="rt-nav-shell">
        <style>{`
          .rt-nav-shell {
            position: sticky;
            top: 8px;
            z-index: 1030;
            width: min(1180px, calc(100% - 20px));
            margin: 10px auto 18px;
          }

          @media (min-width: 1200px) {
            .rt-nav-shell {
              display: inline-block;
              vertical-align: middle;
              width: calc(100% - 230px);
              max-width: calc(100% - 230px);
              margin: 10px 12px 18px 4px;
            }

            .rt-navbar .nav-link,
            .rt-navbar .dropdown-toggle {
              font-size: 0.84rem;
              padding-left: 0.58rem !important;
              padding-right: 0.58rem !important;
            }

            .rt-action-btn,
            .rt-navbar .talk-to-us-btn {
              font-size: 0.84rem;
              padding-left: 0.62rem !important;
              padding-right: 0.62rem !important;
            }

            .rt-brand-copy {
              display: none;
            }
          }

          .rt-navbar {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
            border: 1px solid rgba(126, 231, 255, 0.28);
            border-radius: 18px;
            background:
              linear-gradient(135deg, rgba(8, 12, 24, 0.92), rgba(18, 30, 44, 0.82)),
              rgba(6, 10, 18, 0.9);
            box-shadow:
              0 18px 45px rgba(0, 0, 0, 0.38),
              inset 0 1px 0 rgba(255, 255, 255, 0.12);
            backdrop-filter: blur(18px);
            -webkit-backdrop-filter: blur(18px);
            padding: 0.55rem 0.8rem;
          }

          .rt-brand {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            min-width: 0;
          }

          .rt-brand-mark {
            display: grid;
            place-items: center;
            width: 46px;
            height: 46px;
            border-radius: 14px;
            background: linear-gradient(145deg, rgba(51, 218, 255, 0.26), rgba(255, 202, 58, 0.16));
            border: 1px solid rgba(255, 255, 255, 0.22);
            box-shadow: 0 0 22px rgba(51, 218, 255, 0.18);
            overflow: hidden;
          }

          .rt-brand-mark img {
            width: 36px;
            height: 36px;
            object-fit: contain;
          }

          .rt-brand-copy {
            display: flex;
            flex-direction: column;
            line-height: 1.05;
          }

          .rt-brand-name {
            color: #ffffff;
            font-size: 0.92rem;
            font-weight: 800;
            letter-spacing: 0;
            white-space: nowrap;
          }

          .rt-brand-tagline {
            color: #7ee7ff;
            font-size: 0.68rem;
            font-weight: 600;
            letter-spacing: 0;
            white-space: nowrap;
          }

          .rt-navbar .navbar-toggler {
            width: 44px;
            height: 40px;
            border: 1px solid rgba(126, 231, 255, 0.45);
            border-radius: 12px;
            box-shadow: none;
            padding: 0.25rem 0.45rem;
          }

          .rt-navbar .navbar-toggler:focus {
            box-shadow: 0 0 0 3px rgba(126, 231, 255, 0.22);
          }

          .rt-nav-links {
            gap: 0.28rem;
            flex-wrap: nowrap;
          }

          .rt-navbar .navbar-collapse {
            min-width: 0;
          }

          .rt-navbar .nav-link,
          .rt-navbar .dropdown-toggle {
            color: rgba(255, 255, 255, 0.9) !important;
            font-weight: 700;
            font-size: 0.92rem;
            letter-spacing: 0;
            white-space: nowrap;
            border-radius: 999px;
            padding: 0.64rem 0.9rem !important;
            transition: background-color 180ms ease, color 180ms ease, transform 180ms ease;
          }

          .rt-navbar .nav-link:hover,
          .rt-navbar .dropdown-toggle:hover,
          .rt-navbar .show > .dropdown-toggle {
            color: #051018 !important;
            background: #7ee7ff;
            transform: translateY(-1px);
          }

          .rt-nav-highlight {
            color: #071118 !important;
            background: linear-gradient(90deg, #7ee7ff, #ffd166);
            box-shadow: 0 0 24px rgba(126, 231, 255, 0.22);
          }

          .rt-dropdown-title {
            color: inherit;
          }

          .rt-navbar .dropdown-menu {
            min-width: 240px;
            border: 1px solid rgba(126, 231, 255, 0.28);
            border-radius: 16px;
            background: rgba(6, 12, 22, 0.97);
            box-shadow: 0 20px 45px rgba(0, 0, 0, 0.42);
            padding: 0.55rem;
            max-height: min(70vh, 560px);
            overflow-y: auto;
          }

          .rt-products-menu .dropdown-menu {
            min-width: min(720px, calc(100vw - 32px));
            column-count: 2;
            column-gap: 0.5rem;
          }

          .rt-navbar .dropdown-item {
            color: rgba(255, 255, 255, 0.92) !important;
            border-radius: 11px;
            font-weight: 650;
            padding: 0.6rem 0.72rem;
            white-space: normal;
            break-inside: avoid;
          }

          .rt-navbar .dropdown-item:hover,
          .rt-navbar .dropdown-item:focus {
            color: #071118 !important;
            background: linear-gradient(90deg, #7ee7ff, #ffd166);
          }

          .rt-search-box {
            padding: 0.35rem 0.25rem 0.55rem;
            min-width: 270px;
          }

          .rt-search-input {
            color: #ffffff !important;
            background: rgba(255, 255, 255, 0.08) !important;
            border: 1px solid rgba(126, 231, 255, 0.28) !important;
            border-radius: 12px !important;
            height: 42px;
          }

          .rt-search-input::placeholder {
            color: rgba(255, 255, 255, 0.62);
          }

          .rt-search-input:focus {
            border-color: #7ee7ff !important;
            box-shadow: 0 0 0 3px rgba(126, 231, 255, 0.18) !important;
          }

          .rt-search-empty {
            color: rgba(255, 255, 255, 0.58) !important;
            cursor: default;
          }

          .rt-actions {
            gap: 0.45rem;
          }

          .rt-action-btn,
          .rt-navbar .talk-to-us-btn {
            border: 1px solid rgba(255, 255, 255, 0.24) !important;
            border-radius: 999px !important;
            font-weight: 800 !important;
            padding: 0.62rem 0.95rem !important;
            min-height: 40px;
            white-space: nowrap;
            transition: transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
          }

          .rt-action-btn:hover,
          .rt-navbar .talk-to-us-btn:hover {
            transform: translateY(-1px);
          }

          .rt-btn-login {
            color: #071118 !important;
            background: #7ee7ff !important;
            box-shadow: 0 0 20px rgba(126, 231, 255, 0.22);
          }

          .rt-btn-talk {
            flex: 0 0 auto;
            min-width: 112px;
          }

          .rt-btn-ops {
            color: #071118 !important;
            background: #7fffb2 !important;
          }

          .rt-btn-dashboard {
            color: #071118 !important;
            background: #ffd166 !important;
          }

          .rt-btn-logout {
            color: #ffffff !important;
            background: rgba(255, 255, 255, 0.1) !important;
          }

          .rt-navbar .talk-to-us-btn {
            color: #071118 !important;
            background: linear-gradient(90deg, #ffd166, #ff7ab6) !important;
            animation: rtPulse 1.8s infinite;
          }

          @keyframes rtPulse {
            0% { box-shadow: 0 0 0 0 rgba(255, 209, 102, 0.42); }
            70% { box-shadow: 0 0 0 10px rgba(255, 209, 102, 0); }
            100% { box-shadow: 0 0 0 0 rgba(255, 209, 102, 0); }
          }

          @media (max-width: 1199px) {
            .rt-nav-shell {
              top: 6px;
              width: calc(100% - 14px);
              margin-top: 7px;
            }

            .rt-navbar {
              border-radius: 16px;
              padding: 0.55rem;
            }

            .rt-brand-copy {
              display: none;
            }

            .rt-navbar .navbar-collapse {
              margin-top: 0.75rem;
              padding: 0.65rem;
              border-radius: 16px;
              background: rgba(255, 255, 255, 0.055);
              border: 1px solid rgba(255, 255, 255, 0.08);
            }

            .rt-nav-links,
            .rt-actions {
              align-items: stretch !important;
              width: 100%;
              gap: 0.45rem;
            }

            .rt-navbar .nav-link,
            .rt-navbar .dropdown-toggle,
            .rt-action-btn,
            .rt-navbar .talk-to-us-btn {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 46px;
              margin: 0 !important;
              text-align: center;
            }

            .rt-navbar .dropdown-menu {
              position: static !important;
              transform: none !important;
              width: 100%;
              min-width: 0;
              margin: 0.15rem 0 0.45rem;
              max-height: 320px;
            }

            .rt-products-menu .dropdown-menu {
              min-width: 0;
              column-count: 1;
            }

            .rt-search-box {
              min-width: 0;
              width: 100%;
            }
          }

          @media (max-width: 420px) {
            .rt-brand-mark {
              width: 42px;
              height: 42px;
            }

            .rt-brand-mark img {
              width: 32px;
              height: 32px;
            }

            .rt-navbar .nav-link,
            .rt-navbar .dropdown-toggle,
            .rt-action-btn,
            .rt-navbar .talk-to-us-btn {
              font-size: 0.88rem;
            }
          }
        `}</style>

        <Navbar collapseOnSelect expand="xl" variant="dark" className="rt-navbar">
          <Container fluid className="px-0">
            <Navbar.Brand href="/" className="rt-brand">
              <span className="rt-brand-mark">
                <img src={`${BASE_URL}download/general/logo`} alt="Rainbow Touch" />
              </span>
              <span className="rt-brand-copy">
                <span className="rt-brand-name">Rainbow Touch</span>
                <span className="rt-brand-tagline">Design. Build. Deliver</span>
              </span>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="main-navbar" />

            <Navbar.Collapse id="main-navbar">
              <Nav className="rt-nav-links me-auto align-items-center">
                <NavDropdown
                  title={<span className="rt-dropdown-title">Search</span>}
                  id="search-dropdown"
                  className="rt-search-dropdown"
                >
                  <div className="rt-search-box">
                    <InputGroup>
                      <FormControl
                        className="rt-search-input"
                        type="text"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={this.handleSearch}
                      />
                    </InputGroup>
                  </div>

                  {filteredItems.length > 0 ? (
                    filteredItems.map((item) => (
                      <NavDropdown.Item
                        key={item.id}
                        onClick={() => this.handleItemClick(item.link)}
                      >
                        {item.name}
                      </NavDropdown.Item>
                    ))
                  ) : (
                    <NavDropdown.Item disabled className="rt-search-empty">
                      {searchTerm.trim() ? "No matching products" : "Start typing to search"}
                    </NavDropdown.Item>
                  )}
                </NavDropdown>

                <Nav.Link href="/newproducts" className="rt-nav-highlight">
                  New Arrivals
                </Nav.Link>

                <Nav.Link href="/about">About Us</Nav.Link>

                <NavDropdown
                  title={<span className="rt-dropdown-title">Products</span>}
                  id="products-dropdown"
                  className="rt-products-menu"
                >
                  <NavDropdown.Item href="/products">View All Products</NavDropdown.Item>
                  <NavDropdown.Divider />

                  {PRODUCT_LINKS.map(([link, label]) => (
                    <NavDropdown.Item key={link} href={`/${link}`}>
                      {label}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                <Nav.Link href="/brochures">Brochures</Nav.Link>
              </Nav>

              <Nav className="rt-actions ms-auto align-items-center">
                <Enquiry className="rt-action-btn rt-btn-talk" />

                {localStorage.getItem("token") ? (
                  <>
                    <Button
                      className="rt-action-btn rt-btn-ops"
                      onClick={() => (window.location.href = "/operations")}
                    >
                      Operations
                    </Button>
                    <Button
                      className="rt-action-btn rt-btn-dashboard"
                      onClick={() => (window.location.href = "/dashboard")}
                    >
                      Dashboard
                    </Button>
                    <Button
                      className="rt-action-btn rt-btn-logout"
                      onClick={() => {
                        localStorage.removeItem("token");
                        window.location.href = "/";
                      }}
                    >
                      Logout
                    </Button>
                  </>
                ) : (
                  <Button
                    className="rt-action-btn rt-btn-login"
                    onClick={() => (window.location.href = "/auth")}
                  >
                    Login
                  </Button>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}

export default MenuBar;